// frontend/js/simpleTranslator.js
(function () {
  const STORAGE_KEY = "preferredLanguage";
  const EVENT_NAME = "languagechange";

  let currentLanguage = "en";
  let translations = null; // { en: {...}, fr: {...} }

  const get = (obj, path) => path.split(".").reduce((o, k) => (o && o[k] != null ? o[k] : undefined), obj);
  const format = (str, params) => !params ? str : str.replace(/\{(\w+)\}/g, (_, k) => (k in params ? params[k] : `{${k}}`));

  function _apply(el, key, attr) {
    const val = i18n.t(key);
    if (typeof val === "string") {
      if (attr === "text") el.textContent = val;
      else if (attr === "html") el.innerHTML = val;
      else el.setAttribute(attr, val);
    }
  }

  function translatePage() {
    document.querySelectorAll("[data-i18n]").forEach(el => _apply(el, el.getAttribute("data-i18n"), "text"));
    document.querySelectorAll("[data-i18n-html]").forEach(el => _apply(el, el.getAttribute("data-i18n-html"), "html"));
    document.querySelectorAll("[data-i18n-placeholder]").forEach(el => _apply(el, el.getAttribute("data-i18n-placeholder"), "placeholder"));
    document.querySelectorAll("[data-i18n-title]").forEach(el => _apply(el, el.getAttribute("data-i18n-title"), "title"));
    document.documentElement.setAttribute("lang", currentLanguage);
  }

  const i18n = {
    EVENT_NAME,
    get lang() { return currentLanguage; },

    t(key, params) {
      if (!translations) return key;
      const root = translations[currentLanguage] || translations.en || {};
      // support both { translation: {...} } and flat root
      const base = root.translation || root;
      const raw = get(base, key) ?? key;
      return typeof raw === "string" ? format(raw, params) : key;
    },

    async setLanguage(lng) {
      const lang = (lng || "en").slice(0,2);
      if (!translations || (!translations[lang] && !translations.en)) return;
      currentLanguage = ["en","fr"].includes(lang) ? lang : "en";
      localStorage.setItem(STORAGE_KEY, currentLanguage);
      translatePage();
      document.dispatchEvent(new Event(EVENT_NAME));
    },

    async init({ initialLang, loader } = {}) {
      if (!translations) {
        if (loader) {
          translations = {};
          translations.en = await loader("en");
          translations.fr = await loader("fr");
        } else {
          translations = window.__STATIC_TRANSLATIONS__;
        }
      }
      const saved = localStorage.getItem(STORAGE_KEY);
      const detected = (initialLang || saved || (navigator.language || "en")).slice(0, 2);
      await i18n.setLanguage(detected);
    },

    translatePage
  };

  // Public API
  window.i18n = i18n;
  // Optional alias for legacy code:
  window.t = (k, p) => window.i18n.t(k, p);
})();